// A display string, or a dash when there is nothing to show.
export const formatTextOrDash = (value) => (value == null || value === '' ? '-' : String(value));

// "Name (email)", either half alone, or a dash — never an empty pair of brackets.
export const formatContact = (name, email) => {
  const cleanName = String(name ?? '').trim();
  const cleanEmail = String(email ?? '').trim();
  if (cleanName && cleanEmail) return `${cleanName} (${cleanEmail})`;
  return cleanName || cleanEmail || '-';
};
